/** Numéro de compte OHADA sur 8 chiffres (chiffres uniquement, zéros à droite). */
export const COMPTE_NUMERO_LEN = 8;

export function formatCompte8(compte: string): string {
  const d = (compte ?? "").replace(/\D/g, "");
  if (!d) return "";
  if (d.length >= COMPTE_NUMERO_LEN) return d.slice(0, COMPTE_NUMERO_LEN);
  return d.padEnd(COMPTE_NUMERO_LEN, "0");
}

/** Affichage : optionnellement pad 8, puis espaces XXX XXX XX si 8 chiffres. */
export function formaterCompte(numero: string, padTo8 = false): string {
  const raw = (numero ?? "").trim();
  if (!raw) return "";
  const d = raw.replace(/\D/g, "");
  const n = padTo8 ? formatCompte8(d) : d || raw.replace(/\s/g, "");
  if (!n) return raw;
  if (/^\d{8}$/.test(n)) {
    return `${n.slice(0, 3)} ${n.slice(3, 6)} ${n.slice(6, 8)}`;
  }
  return padTo8 ? n : raw;
}

const chiffresCompte = (raw: string) => (raw ?? "").replace(/\D/g, "");

/** Saisie utilisateur ou code plan : 1 à 8 chiffres, classe OHADA 1–8. */
export function isCompteValide(raw: string): boolean {
  const d = chiffresCompte(raw);
  if (d.length < 1 || d.length > COMPTE_NUMERO_LEN) return false;
  const c = d[0];
  if (c < "1" || c > "8") return false;
  return true;
}

/**
 * Heuristique « compte collectif » en numérotation 8 chiffres : racine …0000.
 * Les comptes auxiliaires (ex. …0001) ne sont pas collectifs.
 */
export function isCompteCollectif(code: string): boolean {
  const d = formatCompte8(code);
  if (d.length !== COMPTE_NUMERO_LEN) return false;
  return d.endsWith("0000");
}

/** Racine numérique → compte collectif 8 chiffres (zéros à droite). */
export function racineVersCompteCollectif(racineDigits: string): string {
  return formatCompte8(racineDigits);
}

/**
 * Fiche fournisseur : numéro de compte général = collectif (…0000).
 * Si l'utilisateur saisit un sous-compte type 40110002, retourne 40110000 (l'auxiliaire reste dans comptes_auxiliaires).
 */
export function formatNumeroCompteCollectifFournisseur(raw: string | null | undefined): string {
  const n8 = formatCompte8(raw ?? "");
  if (!n8) return "40100000";
  if (n8.startsWith("401") && n8.length === 8 && !n8.endsWith("0000")) {
    return `${n8.slice(0, 4)}0000`;
  }
  return n8;
}
